import { useAnchorable } from '../../hooks/useAnchorable';
import { fileAttachmentContainer, fileAttachmentContent } from './FileAttachment.css';
import type { TPostFileAttachmentProps } from './FileAttachment.types';

export const PostFileAttachment = ({ element, rewriteImageSrc, isIndexingDisabled }: TPostFileAttachmentProps) => {
  const { name, size, title, description, data } = element.attrs;

  const { anchorAttributes } = useAnchorable(element.attrs);

  // TODO: i18n
  const fileType = `${data?.file_type} File`;
  const imageUrl = rewriteImageSrc && data?.image_url ? rewriteImageSrc(data.image_url) : data?.image_url;

  return (
    <div {...anchorAttributes} className={fileAttachmentContainer}>
      <div className={fileAttachmentContent}>
        <div className="flex gap-4">
          <div className="mb-4 mr-4 align-top">
            <div className="rounded-[5px] border-1 border-solid border-[#d1d5db] w-[75px] h-[75px] overflow-hidden">
              <img src={imageUrl} alt={name} className="w-full h-full object-cover border-0" />
            </div>
          </div>
          <div>
            <p className="text-[18px] font-semibold leading-[24px]">{title}</p>
            {description && <p className="text-[16px] font-normal leading-[24px] mb-4">{description}</p>}
            <p className="text-[14px] font-normal leading-[20px] text-[#767676]">
              {size} • {fileType}
            </p>
          </div>
        </div>
        <div>
          <a
            href={data?.file_url}
            download={name}
            target="_blank"
            rel={isIndexingDisabled ? 'noreferrer' : undefined}
            className="w-full"
            data-skip-tracking="true"
            data-skip-utms
            data-skip-link-id
          >
            {/* TODO: i18n */}
            <button
              type="button"
              className="drop-shadow-sm cursor-pointer bg-white border border-gray-300 rounded text-[#282828] text-sm font-semibold h-10 leading-[21px] w-full"
            >
              Download
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
